import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";

import { table_tabs, div_title, first, last } from "../../maintainers.module.scss";

const UsersProfiles = ({ data, setData }) => {
	const { profiles } = useSelector((state) => state.maintainers_users);

	const handleChangeSelected = (e, i) => {
		let new_profiles = [...profiles];
		new_profiles[i].selected = e.target.checked;
		setData({ ...data, profiles: new_profiles });
	};

	return (
		<div>
			<table className={table_tabs} border="0" cellSpacing="0" cellPadding="0">
				<thead>
					<tr>
						<th style={{ width: "15%" }}>
							<div className={`${div_title} ${first}`}>#</div>
						</th>
						<th>
							<div className={`${div_title} ${last}`}>Perfiles</div>
						</th>
					</tr>
				</thead>
				<tbody>
					{profiles?.map((prof, i) => {
						return (
							<tr key={i}>
								<td style={{ textAlign: "center" }}>
									<Form.Check
										type="switch"
										id={`switch_profile_${prof.id}`}
										checked={prof.selected}
										onChange={(e) => handleChangeSelected(e, i)}
									/>
								</td>
								<td>{prof.name}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};

export default UsersProfiles;
